import store from "../controller/baseController";
import Enums from "../enums/enums";
import peakUtility from "../function/peakUtility";
import userInfo from "../function/userInfo";
import {
  GetAllocationListWithOutZeroPercent,
  GetAllocationTransactionEquals,
  GetMaxAllocationCanInsert,
  GetMaxAllocationItemCanInsert,
  default as transactionHelper,
} from "../helper/transactionItemHelper.js";
import i18n from "../locales/i18n";
import router from "../router";
import { GetCreateAllocationJournal, GetCreateAllocationJournalItem } from "../service/transaction/transactionHelper";

function GetCreateJournal(createOrEdit, allocationList = []) {
  let journal = {
    id: 0,
    status: null,
    isReconciled: false,
    documentType: createOrEdit,
    date: {
      value: new Date(),
      disable: false,
      validateError: false,
    },
    number: {
      text: "",
      disable: false,
      validateError: false,
    },
    journalItemList: [],
    type: {
      value: Enums.JournalType.GeneralJournal,
      disable: false,
    },
    reference: {
      text: "",
      referenceId: 0,
      referenceTypeId: 0,
      disable: false,
      validateError: false,
    },
    description: {
      text: "",
      disable: false,
      validateError: false,
    },
    contact: {
      value: 0,
      disable: false,
      validateError: false,
    },
    debit: {
      value: "0.00",
      disable: true,
    },
    credit: {
      value: "0.00",
      disable: true,
    },
    tagList: [],
    fileList: [],
    allocationList: [],
    allocationTransactionList: transactionHelper.SetCreateAllocationTransaction(allocationList, true),
    journalValidate: {
      accountNotInput: {
        row: [],
        validateError: false,
      },
      recordDebitCreditAmount: {
        row: [],
        validateError: false,
      },
      diffDebitCreditAlert: {
        validateError: false,
      },
      accountToShouldSelect: {
        row: [],
        validateError: false,
      },
      journalRevenueDocumentSelectExpenseAccount: {
        row: [],
        validateError: false,
      },
      journalExpenseDocumentSelectRevenueAccount: {
        row: [],
        validateError: false,
      },
      journalRevenueDocumentNotSelectRevenueAccount: {
        validateError: false,
      },
      journalExpenseDocumentSelectExpenseAccount: {
        validateError: false,
      },
      journalDocumentNotSelectPaymentAccount: {
        validateError: false,
      },
    },
  };
  journal.journalItemList.push(GetCreateJournalItem(allocationList));
  journal.journalItemList.push(GetCreateJournalItem(allocationList));
  return journal;
}

function GetCreateJournalItem() {
  let journalItem = {
    id: 0,
    account: {
      id: 0,
      code: "",
      name: "",
      nameEng: "",
      nameTH: "",
      referenceTypeId: 0,
      disable: false,
      validateError: false,
    },
    subAccount: {
      code: "",
      name: "",
      referenceId: 0,
      referenceTypeId: 0,
      disable: false,
      validateError: false,
    },
    description: {
      text: "",
      disable: false,
      validateError: false,
    },
    debit: {
      value: "0.00",
      disable: false,
      validateError: false,
    },
    credit: {
      value: "0.00",
      disable: false,
      validateError: false,
    },
    paymentReferenceId: 0,
    stockActivityId: 0,
    isReconciled: false,
    reconciledGroupId: 0,
    isUseTransactionAllocation: true,
    isAccountReferenceFixAsset: false,
    allocationList: [],
    allocationTransactionList: [],
  };
  return journalItem;
}
function SetJournalForEdit(journalTemplate, journalDetail, isCopy) {
  let journalTemplateCreate = null;
  if (journalTemplate && journalDetail) {
    journalTemplateCreate = journalTemplate;
    journalTemplateCreate.id = journalDetail.id;
    journalTemplateCreate.status = journalDetail.status;
    journalTemplateCreate.isReconciled = journalDetail.isReconciled;
    journalTemplateCreate.type.value = journalDetail.type.value;
    journalTemplateCreate.date.value = isCopy
      ? new Date().ToDateJsonString()
      : new Date(journalDetail.date.value).ToDateJsonString();
    journalTemplateCreate.number.text = isCopy ? "" : journalDetail.number.text;
    journalTemplateCreate.reference = {
      text: isCopy ? "" : journalDetail.reference.text,
      referenceId: isCopy ? 0 : journalDetail.reference.referenceId,
      referenceTypeId: isCopy ? 0 : journalDetail.reference.referenceTypeId,
      disable: journalTemplateCreate.reference.referenceId > 0,
    };
    journalTemplateCreate.contact.value = journalDetail.contact.value;
    journalTemplateCreate.description.text = journalDetail.description.text;
    journalTemplateCreate.debit.value = journalDetail.debit.value;
    journalTemplateCreate.credit.value = journalDetail.credit.value;
    journalTemplateCreate.journalItemList = [];
    journalTemplateCreate.allocationList = [];

    if (journalDetail.journalItemList && journalDetail.journalItemList.length > 0) {
      journalDetail.journalItemList.forEach((journalItem) => {
        let journalItemModel = GetCreateJournalItem();
        journalItemModel.id = journalItem.id;
        journalItemModel.account.id = journalItem.account.id;
        journalItemModel.account.code = journalItem.account.code;
        journalItemModel.account.name = journalItem.account.name;
        journalItemModel.account.nameEng = journalItem.account.nameEng;
        journalItemModel.account.nameTH = journalItem.account.nameTH;
        journalItemModel.account.referenceTypeId = journalItem.account.referenceTypeId;

        journalItemModel.subAccount.code = journalItem.subAccount.code;
        journalItemModel.subAccount.name = journalItem.subAccount.name;
        journalItemModel.subAccount.referenceId = journalItem.subAccount.referenceId;
        journalItemModel.subAccount.referenceTypeId = journalItem.subAccount.referenceTypeId;

        journalItemModel.description.text = journalItem.description.text;

        journalItemModel.debit.value = journalItem.debit.value;

        journalItemModel.credit.value = journalItem.credit.value;
        if (!isCopy) {
          journalItemModel.paymentReferenceId = journalItem.paymentReferenceId;
          journalItemModel.isAdjustPayment = journalItem.isAdjustPayment;
          journalItemModel.stockActivityId = journalItem.stockActivityId;
          journalItemModel.isReconciled = journalItem.isReconciled;
          journalItemModel.isAccountReferenceFixAsset = journalItem.isAccountReferenceFixAsset;
          journalItemModel.reconciledGroupId = journalItem.reconciledGroupId;
        }
        journalItemModel.isUseTransactionAllocation = journalItem.isUseTransactionAllocation;
        journalItemModel.allocationList = [];
        journalItemModel.allocationTransactionList = journalItem.allocationTransactionList;

        journalTemplateCreate.journalItemList.push(journalItemModel);
      });
    }

    if (journalDetail.allocationList && journalDetail.allocationList.length > 0) {
      journalTemplateCreate.allocationTransactionList = transactionHelper.SetEditAllocationJournal(
        journalDetail.allocationList,
        store.getters.GetAllocationList
      );
    }
  }

  return journalTemplateCreate;
}
function CalculateJournal(journal) {
  let totalDebit = 0;
  let totalCredit = 0;
  if (journal.journalItemList) {
    for (let journalItem of journal.journalItemList) {
      let debit = journalItem.debit.value.ToNumber();
      let credit = journalItem.credit.value.ToNumber();

      journalItem.debit.value = debit.FormatMoney();
      journalItem.credit.value = credit.FormatMoney();

      totalCredit = peakUtility.PeakOperatorAdd(totalCredit, journalItem.credit.value.ToNumber());
      totalDebit = peakUtility.PeakOperatorAdd(totalDebit, journalItem.debit.value.ToNumber());
      journalItem.isDebit = debit - credit > 0;
      if (journalItem.isDebit) {
        journalItem.itemNetAmountTotal = debit.FormatMoney();
      } else {
        journalItem.itemNetAmountTotal = credit.FormatMoney();
      }
    }
    journal.debit.value = totalDebit.FormatMoney();
    journal.credit.value = totalCredit.FormatMoney();
  }
}
function GetJournalStatus(status, isDeleted, validationStatus) {
  let journalStatusClass = "";
  let journalStatusName = "";
  let journalTextColor = "";
  if (isDeleted) {
    journalStatusName = i18n.t("Text_Status_Voided");
    journalStatusClass = "statusColorGrey";
    journalTextColor = "#9d9eb1";
  } else if (
    (validationStatus == Enums.ValidationStatus.Warning || validationStatus == Enums.ValidationStatus.Urgent) &&
    status != Enums.JournalStatusType.Approved
  ) {
    journalStatusName = i18n.t("Table_Tap_ShouldBeCheck");
    journalStatusClass = "statusColorRed";
    journalTextColor = "#f1502f";
  } else {
    switch (status) {
      case Enums.JournalStatusType.AwaitRecord:
        journalStatusName = i18n.t("Text_Status_Await_check");
        journalStatusClass = "statusColorOrange";
        journalTextColor = "#ff9e40";
        break;
      case Enums.JournalStatusType.Draft:
        journalStatusName = i18n.t("Table_Tap_Draft");
        journalStatusClass = "statusColorBorderGrey";
        journalTextColor = "#9d9eb1";
        break;
      case Enums.JournalStatusType.AwaitApproval:
        journalStatusName = i18n.t("Table_Tap_Await_Approve");
        journalStatusClass = "statusColorBlue";
        journalTextColor = "#3297ff";
        break;
      case Enums.JournalStatusType.Approved:
        journalStatusName = i18n.t("Text_Status_Approval");
        journalStatusClass = "statusColorGreen";
        journalTextColor = "#4cc27d";
        break;
    }
  }
  return { journalStatusName, journalStatusClass, journalTextColor };
}
function GetJournalTypeDropdown() {
  return [
    { name: i18n.t("Menu_GeneralJournal"), value: Enums.JournalType.GeneralJournal },
    { name: i18n.t("Menu_PurchaseJournal"), value: Enums.JournalType.PurchaseJournal },
    { name: i18n.t("Menu_SalesJournal"), value: Enums.JournalType.SalesJournal },
    { name: i18n.t("Menu_PaymentJournal"), value: Enums.JournalType.PaymentJournal },
    { name: i18n.t("Menu_ReceivedJournal"), value: Enums.JournalType.ReceiveJournal },
  ];
}

function ValidateAccountNotInput(journalItem, index, rowAccountNotInput) {
  if (!(journalItem.account && journalItem.account.id > 0)) {
    rowAccountNotInput.push(index + 1);
    journalItem.account.validateError = true;
  } else {
    journalItem.account.validateError = false;
  }
}

function ValidateDescriptionJournal(journalItem) {
  if (
    journalItem.description &&
    (journalItem.description.text.trim().length > 1000 || journalItem.description.text.trim().length == 0)
  ) {
    journalItem.description.validateError = true;
  } else {
    journalItem.description.validateError = false;
  }
}

function ValidateRecordDebitCreditAmount(journalItem, index, rowRecordDebitCreditAmount) {
  const creditValue = journalItem.credit.value.ToNumber();
  const debitValue = journalItem.debit.value.ToNumber();
  if (creditValue === 0 && debitValue === 0) {
    rowRecordDebitCreditAmount.push(index + 1);
    journalItem.credit.validateError = true;
    journalItem.debit.validateError = true;
  } else if (creditValue < 0 || debitValue < 0) {
    rowRecordDebitCreditAmount.push(index + 1);
    journalItem.credit.validateError = creditValue < 0;
    journalItem.debit.validateError = debitValue < 0;
  } else {
    journalItem.credit.validateError = false;
    journalItem.debit.validateError = false;
  }
}

function ValidateAccountToShouldSelect(journalItem, rowAccountToShouldSelect) {
  if (journalItem.account && CheckCanValidateReferenceType(journalItem.account.referenceTypeId)) {
    if (!(journalItem.subAccount && journalItem.subAccount.code)) {
      rowAccountToShouldSelect.push(journalItem.account.code);
    }
  }
}

function CheckCanValidateReferenceType(referenceTypeId) {
  let canValidate = false;
  switch (referenceTypeId) {
    case Enums.JournalAccountReferenceType.BankAccount:
    case Enums.JournalAccountReferenceType.Cheque:
    case Enums.JournalAccountReferenceType.ProductTemplate:
    case Enums.JournalAccountReferenceType.Contact:
      canValidate = true;
      break;
  }

  return canValidate;
}

function ValidateJournalDocumentNotSelectPaymentAccount(journalItem, rowJournalSelectPaymentAccount) {
  if (
    journalItem.account &&
    journalItem.account.code &&
    (journalItem.account.code.substring(0, 3) === "211" ||
      journalItem.account.code.substring(0, 3) === "111" ||
      journalItem.account.code === "113102" ||
      journalItem.account.code === "212102")
  ) {
    rowJournalSelectPaymentAccount.push(journalItem.account.code);
  }
}

function ValidateJournalExpenseDocumentSelectRevenueAccount(
  journalItem,
  rowJournalExpenseDocumentSelectRevenueAccount
) {
  if (journalItem.account && journalItem.account.code && journalItem.account.code.substring(0, 1) === "4") {
    rowJournalExpenseDocumentSelectRevenueAccount.push(journalItem.account.code);
  }
}

function ValidateRevenueDocumentSelectRevenueAccount(journalItem, isRevenueDocumentNotSelectRevenueAccount) {
  if (isRevenueDocumentNotSelectRevenueAccount) {
    return true;
  } else {
    if (journalItem.account && journalItem.account.code && journalItem.account.code.substring(0, 1) === "4") {
      return true;
    }
    return false;
  }
}

function ValidateExpenseDocumentSelectExpenseAccount(journalItem, isExpenseDocumentSelectExpenseAccount) {
  if (isExpenseDocumentSelectExpenseAccount) {
    return true;
  } else {
    if (journalItem.account && journalItem.account.code && journalItem.account.code.substring(0, 1) === "5") {
      return true;
    }
    return false;
  }
}

function ValidateJournal(journal) {
  if (journal.journalItemList && journal.journalItemList.length > 0) {
    let rowAccountNotInput = [];
    let rowRecordDebitCreditAmount = [];
    let rowAccountToShouldSelect = [];
    let rowJournalRevenueDocumentSelectExpenseAccount = [];
    let rowJournalSelectPaymentAccount = [];
    let rowJournalExpenseDocumentSelectRevenueAccount = [];
    journal.journalItemList.forEach((journalItem, index) => {
      ValidateAccountNotInput(journalItem, index, rowAccountNotInput);
      ValidateRecordDebitCreditAmount(journalItem, index, rowRecordDebitCreditAmount);
      ValidateAccountToShouldSelect(journalItem, rowAccountToShouldSelect);
      ValidateDescriptionJournal(journalItem);
      if (
        journal.type.value == Enums.JournalType.PaymentJournal ||
        journal.type.value == Enums.JournalType.ReceiveJournal
      ) {
        ValidateJournalDocumentNotSelectPaymentAccount(journalItem, rowJournalSelectPaymentAccount);
      }
    });

    journal.journalValidate.accountNotInput.row = rowAccountNotInput;
    journal.journalValidate.accountNotInput.validateError = rowAccountNotInput.length > 0;

    journal.journalValidate.recordDebitCreditAmount.row = rowRecordDebitCreditAmount;
    journal.journalValidate.recordDebitCreditAmount.validateError = rowRecordDebitCreditAmount.length > 0;

    journal.journalValidate.diffDebitCreditAlert.validateError =
      journal.credit.value.ToNumber() !== journal.debit.value.ToNumber();

    journal.journalValidate.accountToShouldSelect.row = rowAccountToShouldSelect;
    journal.journalValidate.accountToShouldSelect.validateError = rowAccountToShouldSelect.length > 0;

    journal.journalValidate.journalRevenueDocumentSelectExpenseAccount.row =
      rowJournalRevenueDocumentSelectExpenseAccount;
    journal.journalValidate.journalRevenueDocumentSelectExpenseAccount.validateError =
      rowJournalRevenueDocumentSelectExpenseAccount.length > 0;

    journal.journalValidate.journalExpenseDocumentSelectRevenueAccount.row =
      rowJournalExpenseDocumentSelectRevenueAccount;
    journal.journalValidate.journalExpenseDocumentSelectRevenueAccount.validateError =
      rowJournalExpenseDocumentSelectRevenueAccount.length > 0;

    if (
      journal.type.value == Enums.JournalType.PaymentJournal ||
      journal.type.value == Enums.JournalType.ReceiveJournal
    ) {
      journal.journalValidate.journalDocumentNotSelectPaymentAccount.validateError =
        rowJournalSelectPaymentAccount.length == 0;
    } else {
      journal.journalValidate.journalDocumentNotSelectPaymentAccount.validateError = false;
    }
  }
}

function ValidateJournalBeforeUpdate(journal) {
  if (journal.journalItemList && journal.journalItemList.length > 0) {
    let rowAccountNotInput = [];
    let rowRecordDebitCreditAmount = [];
    journal.journalItemList.forEach((journalItem, index) => {
      ValidateAccountNotInput(journalItem, index, rowAccountNotInput);
      ValidateRecordDebitCreditAmount(journalItem, index, rowRecordDebitCreditAmount);
      ValidateDescriptionJournal(journalItem);
    });

    journal.journalValidate.accountNotInput.row = rowAccountNotInput;
    journal.journalValidate.accountNotInput.validateError = rowAccountNotInput.length > 0;

    journal.journalValidate.recordDebitCreditAmount.row = rowRecordDebitCreditAmount;
    journal.journalValidate.recordDebitCreditAmount.validateError = rowRecordDebitCreditAmount.length > 0;
  }
}

const ValidateJournalAllocationValidateError = (journal) => {
  const validateAllocationJournalLimitError = ValidateAllocationJournalLimitByPackage(journal);
  const validateAllocationJournalItemLimitError = ValidateAllocationJournalItemLimitByPackage(journal);

  return validateAllocationJournalLimitError || validateAllocationJournalItemLimitError;
};

const ValidateAllocationJournalLimitByPackage = (journal) => {
  const maxAllocationCanInsert = GetMaxAllocationCanInsert(true);
  const maxAllocationItemCanInsert = GetMaxAllocationItemCanInsert();
  let validateAllocationJournalLimitError = false;
  if (journal.allocationTransactionList) {
    let countAllocation = 0;
    for (const allocationTransaction of journal.allocationTransactionList) {
      let countAllocationItem = 0;

      if (allocationTransaction.allocationItemList && allocationTransaction.allocationItemList.length > 0) {
        for (const allocationItem of allocationTransaction.allocationItemList) {
          if (allocationItem.id > 0 && allocationItem.percent) {
            countAllocationItem++;
          }
        }
      }

      if (countAllocationItem > maxAllocationItemCanInsert) {
        validateAllocationJournalLimitError = true;
      }

      if (countAllocationItem > 0) {
        countAllocation++;
      }

      if (countAllocation > maxAllocationCanInsert) {
        validateAllocationJournalLimitError = true;
      }

      if (validateAllocationJournalLimitError) {
        break;
      }
    }
  }
  return validateAllocationJournalLimitError;
};

const ValidateAllocationJournalItemLimitByPackage = (journal) => {
  const maxAllocationCanInsert = GetMaxAllocationCanInsert();
  let validateAllocationJournalItemLimitError = false;
  if (maxAllocationCanInsert !== Infinity) {
    if (journal.journalItemList && journal.journalItemList.length > 0) {
      const allocationJournal = GetAllocationListWithOutZeroPercent(
        GetCreateAllocationJournal(journal.allocationTransactionList)
      );
      for (const journalItem of journal.journalItemList) {
        if (!journalItem.isUseTransactionAllocation) {
          const allocationJournalItem = GetAllocationListWithOutZeroPercent(
            GetCreateAllocationJournalItem(journalItem.allocationTransactionList)
          );
          let allocationTransactionEquals = GetAllocationTransactionEquals(allocationJournal, allocationJournalItem);
          if (!allocationTransactionEquals) {
            validateAllocationJournalItemLimitError = true;
            break;
          }
        }
      }
    }
  }
  return validateAllocationJournalItemLimitError;
};

function ValideteBeforeCreateJournal(journal) {
  let valideted = false;
  let dateValidateError = journal.date.validateError || !journal.date.value;
  let numberValidateError = journal.number.validateError || journal.number.text == "";
  let referenceValidateError = journal.reference.validateError;
  let descriptionValidateError =
    journal.description.validateError || !journal.description.text || journal.description.text.trim() == "";
  let accountNotInputError = journal.journalValidate.accountNotInput.validateError;
  let recordDebitCreditAmountError = journal.journalValidate.recordDebitCreditAmount.validateError;
  let diffDebitCreditAlertError = journal.journalValidate.diffDebitCreditAlert.validateError;
  let journalItemAlertError = ValidateJournalItem(journal.journalItemList);
  let allocationValidateError = ValidateJournalAllocationValidateError(journal);
  if (journal.isImport) {
    numberValidateError = false;
  }
  if (
    !dateValidateError &&
    !numberValidateError &&
    !referenceValidateError &&
    !descriptionValidateError &&
    !accountNotInputError &&
    !recordDebitCreditAmountError &&
    !diffDebitCreditAlertError &&
    !journalItemAlertError &&
    !allocationValidateError
  ) {
    valideted = true;
  } else {
    journal.date.validateError = dateValidateError;
    journal.number.validateError = numberValidateError;
    journal.reference.validateError = referenceValidateError;
    journal.description.validateError = descriptionValidateError;

    if (diffDebitCreditAlertError) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validete_DiffDebitCreditAlert_Text"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }

    if (allocationValidateError) {
      const validateAllocationJournalLimitError = ValidateAllocationJournalLimitByPackage(journal);
      const validateAllocationJournalItemLimitError = ValidateAllocationJournalItemLimitByPackage(journal);
      if (validateAllocationJournalLimitError) {
        const maxAllocationCanInsert = GetMaxAllocationCanInsert(true);
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Package_Limit_Assigned_Classification_Group", { x: maxAllocationCanInsert }),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      } else if (validateAllocationJournalItemLimitError) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Package_Limit_Assigned_Classification_TransactionItem"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    }

    if (
      dateValidateError ||
      numberValidateError ||
      referenceValidateError ||
      descriptionValidateError ||
      accountNotInputError ||
      recordDebitCreditAmountError
    ) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("AlertNoti_Create_Input_Error"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }
  }
  return valideted;
}
function ValidateJournalItem(journalItem) {
  let journalItemError = false;
  if (journalItem && journalItem.length > 0) {
    for (let count = 0; journalItem.length > count; count++) {
      if (
        journalItem[count].description.text &&
        (journalItem[count].description.text.trim().length == 0 ||
          journalItem[count].description.text.trim().length > 1000)
      ) {
        journalItemError = true;
        break;
      }
    }
  } else {
    journalItemError = true;
  }
  return journalItemError;
}
function RedirectToDocumentDetail(referenceId, journalRefType) {
  let linkName = "";
  switch (journalRefType) {
    case Enums.JournalRefType.Quotation: {
      linkName = "income_quotationDetail";
      break;
    }
    case Enums.JournalRefType.Deposit:
    case Enums.JournalRefType.PaymentDeposit: {
      linkName = "income_depositDetail";
      break;
    }
    case Enums.JournalRefType.Invoice:
    case Enums.JournalRefType.PaymentInvoice: {
      linkName = "income_invoiceDetail";
      break;
    }
    case Enums.JournalRefType.Receipt:
    case Enums.JournalRefType.PaymentReceipt: {
      linkName = "income_receiptDetail";
      break;
    }
    case Enums.JournalRefType.TaxInvoice: {
      linkName = "income_taxinvoiceDetail";
      break;
    }
    case Enums.JournalRefType.PurchaseOrder: {
      linkName = "expense_PODetail";
      break;
    }
    case Enums.JournalRefType.ReceivedDeposit:
    case Enums.JournalRefType.PaymentReceivedDeposit:
    case Enums.JournalRefType.ReceivedTaxInvoiceDeposit: {
      linkName = "expense_depositDetail";
      break;
    }
    case Enums.JournalRefType.GoodsReceipt: {
      linkName = "expense_goodsReceiptDetail";
      break;
    }
    case Enums.JournalRefType.InvoiceReceipt:
    case Enums.JournalRefType.PaymentInvoiceReceipt:
    case Enums.JournalRefType.ReceivedTaxInvoiceInvoiceReceipt: {
      linkName = "expense_invoiceReceiptDetail";
      break;
    }
    case Enums.JournalRefType.Expense:
    case Enums.JournalRefType.PaymentExpense:
    case Enums.JournalRefType.ReceivedTaxInvoiceExpense: {
      linkName = "expense_invoiceDetail";
      break;
    }
    case Enums.JournalRefType.ExpenseTaxInvoice: {
      linkName = "expense_taxinvoiceDetail";
      break;
    }
    case Enums.JournalRefType.PaymentCreditNote:
    case Enums.JournalRefType.CreditNote: {
      linkName = "income_creditNoteDetail";
      break;
    }
    case Enums.JournalRefType.BillingNoteInvoice: {
      linkName = "income_billingNoteDetail";
      break;
    }
    case Enums.JournalRefType.BillingNoteExpense: {
      linkName = "expense_billingNoteDetail";
      break;
    }
    case Enums.JournalRefType.CreditNoteExpense:
    case Enums.JournalRefType.PaymentCreditNoteExpense:
    case Enums.JournalRefType.ReceivedTaxInvoiceCreditNote: {
      linkName = "expense_creditNoteDetail";
      break;
    }
    case Enums.JournalRefType.DebitNote:
    case Enums.JournalRefType.PaymentDebitNote: {
      linkName = "income_debitNoteDetail";
      break;
    }
    case Enums.JournalRefType.DebitNoteExpense:
    case Enums.JournalRefType.PaymentDebitNoteExpense:
    case Enums.JournalRefType.ReceivedTaxInvoiceDebitNote: {
      linkName = "expense_debitNoteDetail";
      break;
    }
    case Enums.JournalRefType.Deposit:
    case Enums.JournalRefType.PaymentDeposit: {
      linkName = "income_depositDetail";
      break;
    }
    case Enums.JournalRefType.ReceivedDeposit:
    case Enums.JournalRefType.PaymentReceivedDeposit:
    case Enums.JournalRefType.ReceivedTaxInvoiceDeposit: {
      linkName = "expense_depositDetail";
      break;
    }
    case Enums.JournalRefType.GoodsReceipt: {
      linkName = "expense_goodsReceiptDetail";
      break;
    }
    case Enums.JournalRefType.InvoiceReceipt:
    case Enums.JournalRefType.PaymentInvoiceReceipt:
    case Enums.JournalRefType.ReceivedTaxInvoiceInvoiceReceipt: {
      linkName = "expense_invoiceReceiptDetail";
      break;
    }
  }
  if (linkName) {
    router.open({
      name: linkName,
      query: { emi: userInfo.MerchantId().PeakEncryption(), eii: referenceId.PeakEncryption() },
    });
  } else if (journalRefType === Enums.JournalRefType.PP30) {
    window.open(
      `${process.env.VUE_APP_PeakEngine}Tax/PP30Detail?emi=${userInfo
        .MerchantId()
        .PeakEncryption()}&eii=${referenceId.PeakEncryption()}`
    );
  } else if (journalRefType === Enums.JournalRefType.TaxPP30) {
    window.open(
      `${process.env.VUE_APP_PeakTax}pp30/pp30Detail?emi=${userInfo
        .MerchantId()
        .PeakEncryption()}&epi=${referenceId.PeakEncryption()}`
    );
  } else if (journalRefType === Enums.JournalRefType.TaxPND3) {
    window.open(
      `${process.env.VUE_APP_PeakTax}pnd/pnd3Detail?emi=${userInfo
        .MerchantId()
        .PeakEncryption()}&epi=${referenceId.PeakEncryption()}&epti=${Enums.PndType.PND3.PeakEncryption()}`
    );
  } else if (journalRefType === Enums.JournalRefType.TaxPND53) {
    window.open(
      `${process.env.VUE_APP_PeakTax}pnd/pnd53Detail?emi=${userInfo
        .MerchantId()
        .PeakEncryption()}&epi=${referenceId.PeakEncryption()}&epti=${Enums.PndType.PND53.PeakEncryption()}`
    );
  }
}
function CheckCanRedirectToDocumentDetail(journalRefType) {
  let isCanLink = false;
  switch (journalRefType) {
    case Enums.JournalRefType.Quotation:
    case Enums.JournalRefType.Invoice:
    case Enums.JournalRefType.PaymentInvoice:
    case Enums.JournalRefType.Receipt:
    case Enums.JournalRefType.TaxInvoice:
    case Enums.JournalRefType.PurchaseOrder:
    case Enums.JournalRefType.Expense:
    case Enums.JournalRefType.PaymentExpense:
    case Enums.JournalRefType.ReceivedTaxInvoiceExpense:
    case Enums.JournalRefType.ExpenseTaxInvoice:
    case Enums.JournalRefType.CreditNote:
    case Enums.JournalRefType.BillingNoteInvoice:
    case Enums.JournalRefType.BillingNoteExpense:
    case Enums.JournalRefType.CreditNoteExpense:
    case Enums.JournalRefType.ReceivedTaxInvoiceCreditNote:
    case Enums.JournalRefType.DebitNote:
    case Enums.JournalRefType.BankAccount:
    case Enums.JournalRefType.TaxPP30:
    case Enums.JournalRefType.TaxPND3:
    case Enums.JournalRefType.TaxPND53:
    case Enums.JournalRefType.ReceivedTaxInvoiceDebitNote:
    case Enums.JournalRefType.PaymentCreditNote:
    case Enums.JournalRefType.PaymentCreditNoteExpense:
    case Enums.JournalRefType.PaymentDebitNote:
    case Enums.JournalRefType.PaymentDebitNoteExpense:
    case Enums.JournalRefType.DebitNoteExpense:
    case Enums.JournalRefType.Deposit:
    case Enums.JournalRefType.ReceivedDeposit:
    case Enums.JournalRefType.PaymentDeposit:
    case Enums.JournalRefType.PaymentReceivedDeposit:
    case Enums.JournalRefType.ReceivedTaxInvoiceDeposit:
    case Enums.JournalRefType.GoodsReceipt:
    case Enums.JournalRefType.InvoiceReceipt:
    case Enums.JournalRefType.PaymentInvoiceReceipt:
    case Enums.JournalRefType.ReceivedTaxInvoiceInvoiceReceipt:
    case Enums.JournalRefType.PaymentReceipt:
      isCanLink = true;
      break;
  }
  return isCanLink;
}

function SelectJournalAccount(journalAccountItem, account) {
  if (account) {
    journalAccountItem.name = account.name.locale;
    journalAccountItem.nameEng = account.name.english;
    journalAccountItem.nameTH = account.name.thai;
    journalAccountItem.code = account.code;
    journalAccountItem.id = account.id;
    journalAccountItem.referenceTypeId = account.referenceTypeId;
  }
}

function SelectJournalSubAccount(journalSubAccountItem, subAccount) {
  if (subAccount) {
    journalSubAccountItem.referenceId = subAccount.id;
    journalSubAccountItem.name = subAccount.name;
    journalSubAccountItem.code = subAccount.code;
  } else {
    journalSubAccountItem.referenceId = 0;
    journalSubAccountItem.name = "";
    journalSubAccountItem.code = "";
  }
}

function SuggestionDescriptionSubAccount(newSubAccountName, oldSubAccountName, oldAccountName, allDescription) {
  let suggestionDescription = "";
  newSubAccountName = newSubAccountName ? newSubAccountName.trim() : "";
  oldSubAccountName = oldSubAccountName ? oldSubAccountName.trim() : "";
  oldAccountName = oldAccountName ? oldAccountName.trim() : "";
  allDescription = allDescription ? allDescription.trim() : "";
  if (!allDescription) {
    suggestionDescription = oldAccountName + " - " + newSubAccountName;
  } else if (newSubAccountName) {
    if (oldSubAccountName) {
      allDescription = allDescription.replace(" - " + oldSubAccountName, "");
    }

    if (oldAccountName) {
      let indexOfFirst = allDescription.indexOf(oldAccountName);
      if (indexOfFirst == 0) {
        let oldAccountNameLength = oldAccountName.length;
        suggestionDescription =
          allDescription.slice(0, oldAccountNameLength).trim() +
          " - " +
          newSubAccountName +
          " " +
          allDescription.slice(oldAccountNameLength).trim();
      } else {
        suggestionDescription = oldAccountName + " - " + newSubAccountName + " " + allDescription;
      }
    }
  } else {
    suggestionDescription = allDescription;
  }
  return suggestionDescription.trim();
}

function SetDescriptionSubAccount(journalItem, subAccountItem) {
  let oldSubAccountName = "";
  let newSubAccountName = "";
  let oldAccountName = journalItem.account.name;

  if (journalItem.subAccount.name || journalItem.subAccount.code) {
    let oldName = journalItem.subAccount.name ? journalItem.subAccount.name.trim() : "";
    let oldCode = journalItem.subAccount.code ? journalItem.subAccount.code.trim() : "";
    oldSubAccountName = oldCode + " - " + oldName;
  }
  if (subAccountItem && (subAccountItem.name || subAccountItem.code)) {
    let newName = subAccountItem.name ? subAccountItem.name.trim() : "";
    let newCode = subAccountItem.code ? subAccountItem.code.trim() : "";
    newSubAccountName = newCode + " - " + newName;
  }

  journalItem.description.text = SuggestionDescriptionSubAccount(
    newSubAccountName,
    oldSubAccountName,
    oldAccountName,
    journalItem.description.text
  );
}

function RevomeTextDescription(oldSubAccountName, allDescription) {
  let description = "";
  oldSubAccountName = oldSubAccountName ? oldSubAccountName.trim() : "";
  allDescription = allDescription ? allDescription.trim() : "";
  if (!allDescription) {
    description = "";
  } else if (oldSubAccountName) {
    description = allDescription.replace(" - " + oldSubAccountName, "");
  } else {
    description = allDescription;
  }
  return description.trim();
}

function RemoveSubAccountFromDescription(journalItem) {
  let oldSubAccountName = "";
  if (journalItem.subAccount.name || journalItem.subAccount.code) {
    let oldName = journalItem.subAccount.name ? journalItem.subAccount.name.trim() : "";
    let oldCode = journalItem.subAccount.code ? journalItem.subAccount.code.trim() : "";
    oldSubAccountName = oldCode + " - " + oldName;
  }

  journalItem.description.text = RevomeTextDescription(oldSubAccountName, journalItem.description.text);
}

function SuggestionDescriptionAccount(newDescription, oldAccountNameTh, oldAccountNameEn, allDescription) {
  let suggestionDescription = "";
  newDescription = newDescription ? newDescription.trim() : "";
  oldAccountNameTh = oldAccountNameTh ? oldAccountNameTh.trim() : "";
  oldAccountNameEn = oldAccountNameEn ? oldAccountNameEn.trim() : "";
  allDescription = allDescription ? allDescription.trim() : "";
  if (!allDescription) {
    suggestionDescription = newDescription;
  } else if (newDescription) {
    if (oldAccountNameTh) {
      let oldAccountNameThForSearch = oldAccountNameTh == allDescription ? oldAccountNameTh : oldAccountNameTh + " ";
      let indexOfFirst = allDescription.indexOf(oldAccountNameThForSearch);
      if (indexOfFirst == 0) {
        let oldAccountNameThLength = oldAccountNameTh.length;
        allDescription = allDescription.substring(oldAccountNameThLength).trim();
      }
    }
    if (oldAccountNameEn) {
      let oldAccountNameEnForSearch = oldAccountNameEn == allDescription ? oldAccountNameEn : oldAccountNameEn + " ";
      let indexOfFirst = allDescription.indexOf(oldAccountNameEnForSearch);
      if (indexOfFirst == 0) {
        let oldAccountNameEnLength = oldAccountNameEn.length;
        allDescription = allDescription.substring(oldAccountNameEnLength).trim();
      }
    }
    suggestionDescription = newDescription + " " + allDescription;
  } else {
    suggestionDescription = allDescription;
  }
  return suggestionDescription.trim();
}

function SetDescriptionAccount(journalItem, item) {
  let newAccountName = item.name.locale;
  let oldAccountNameTh = journalItem.account.name;
  let oldAccountNameEn = journalItem.account.name;

  journalItem.description.text = SuggestionDescriptionAccount(
    newAccountName,
    oldAccountNameTh,
    oldAccountNameEn,
    journalItem.description.text
  );
}

function GetBankAccountListForSelectSubAccount(accountCode, bankAccountList) {
  let bankAccountListForSelectSubAccount = [];
  if (bankAccountList && bankAccountList.length > 0) {
    switch (accountCode) {
      case Enums.ChartaccountPaymentNotDisplayPayment.Cash.toString(): //เงินสด
        bankAccountListForSelectSubAccount = bankAccountList.filter(
          (x) => x.bankAccountType == Enums.BankAccountType.Cash
        );
        break;
      case Enums.ChartaccountPaymentNotDisplayPayment.BankCurrentAccount.toString(): //ธนาคาร กระแส
        bankAccountListForSelectSubAccount = bankAccountList.filter(
          (x) => x.bankAccountType == Enums.BankAccountType.Bank && x.bankType == Enums.BankType.CurrentAccount
        );
        break;
      case Enums.ChartaccountPaymentNotDisplayPayment.BankSavingsAccount.toString(): //ธนาคาร ออมทรัพย์
        bankAccountListForSelectSubAccount = bankAccountList.filter(
          (x) => x.bankAccountType == Enums.BankAccountType.Bank && x.bankType == Enums.BankType.SavingAccount
        );
        break;
      case Enums.ChartaccountPaymentNotDisplayPayment.BankFixedDeposit.toString(): //ธนาคาร ประจำ
        bankAccountListForSelectSubAccount = bankAccountList.filter(
          (x) => x.bankAccountType == Enums.BankAccountType.Bank && x.bankType == Enums.BankType.FixedDeposit
        );
        break;
      case Enums.ChartaccountPaymentNotDisplayPayment.NonRefundableInterestPayment.toString(): //สำรองรับจ่าย
        bankAccountListForSelectSubAccount = bankAccountList.filter(
          (x) => x.bankAccountType == Enums.BankAccountType.ExpenseClaim
        );
        break;
      case Enums.AccountDefaultForEWalletType.DefaultEWallet.toString(): //กระเป๋าเงินอิเล็กทรอนิกส์
        bankAccountListForSelectSubAccount = bankAccountList.filter(
          (x) => x.bankAccountType == Enums.BankAccountType.EWallet
        );
        break;
      default:
        bankAccountListForSelectSubAccount = bankAccountList;
        break;
    }
  }
  return bankAccountListForSelectSubAccount;
}

function GetReversedJournalDescription(description, oldNumber) {
  return `${i18n.t("Btn_Reversing")} ${oldNumber} ${description}`;
}

export const ConvertToJournalBalanceWithDebitAmount = (debitAmount, creditAmount) => {
  const debitAmountNumber = debitAmount ? debitAmount.ToNumber() : 0;
  const creditAmountNumber = creditAmount ? creditAmount.ToNumber() : 0;
  let journalBalance = { debit: debitAmountNumber, credit: creditAmountNumber };
  if (debitAmountNumber > 0) {
    journalBalance = { debit: debitAmountNumber, credit: 0 };
  } else if (debitAmountNumber < 0) {
    journalBalance = { debit: 0, credit: Math.abs(debitAmountNumber) };
  }
  return journalBalance;
};

export const ConvertToJournalBalanceWithCreditAmount = (debitAmount, creditAmount) => {
  const debitAmountNumber = debitAmount ? debitAmount.ToNumber() : 0;
  const creditAmountNumber = creditAmount ? creditAmount.ToNumber() : 0;
  let journalBalance = { debit: debitAmountNumber, credit: creditAmountNumber };
  if (creditAmountNumber > 0) {
    journalBalance = { debit: 0, credit: creditAmountNumber };
  } else if (creditAmountNumber < 0) {
    journalBalance = { debit: Math.abs(creditAmountNumber), credit: 0 };
  }
  return journalBalance;
};

export const GetTransactionNameForJournalModal = (
  transactionType,
  financeType,
  transactionItemType = Enums.TransactionItemType.None
) => {
  let name = "";
  switch (transactionType) {
    case Enums.TransactionType.Quotation:
      if (financeType == Enums.FinanceType.InFlow) {
        name = i18n.t("Quotation");
      } else {
        if (transactionItemType == Enums.TransactionItemType.Asset) {
          name = i18n.t("Purchase_Order_Asset");
        } else {
          name = i18n.t("Purchase_Order");
        }
      }
      break;
    case Enums.TransactionType.Deposit:
      if (financeType == Enums.FinanceType.InFlow) {
        name = i18n.t("Deposit_Receipt");
      } else {
        name = i18n.t("Deposit_Payment");
      }
      break;
    case Enums.TransactionType.GoodsReceipt:
      name = i18n.t("Goods_Receipt");
      break;
    case Enums.TransactionType.InvoiceReceipt:
      name = i18n.t("Invoice_Receipt");
      break;
    case Enums.TransactionType.Invoice:
      if (financeType == Enums.FinanceType.InFlow) {
        name = i18n.t("Invoice");
      } else {
        if (transactionItemType == Enums.TransactionItemType.Asset) {
          name = i18n.t("Purchase_New_Asset");
        } else {
          name = i18n.t("Expense");
        }
      }
      break;
    case Enums.TransactionType.Receipt:
      name = i18n.t("Receipt");
      break;
    case Enums.TransactionType.TaxInvoice:
      if (financeType == Enums.FinanceType.InFlow) {
        name = i18n.t("Sales_Tax_Invoice");
      } else {
        name = i18n.t("Purchase_Tax_Invoice");
      }
      break;
    case Enums.TransactionType.CreditNote:
      if (financeType == Enums.FinanceType.InFlow) {
        name = i18n.t("Credit_Note");
      } else {
        name = i18n.t("Receive_Credit_Note");
      }

      break;
    case Enums.TransactionType.DebitNote:
      if (financeType == Enums.FinanceType.InFlow) {
        name = i18n.t("Debit_Note");
      } else {
        name = i18n.t("Receive_Debit_Note");
      }
      break;
    case Enums.TransactionType.BillingNote:
      if (financeType == Enums.FinanceType.InFlow) {
        name = i18n.t("Menu_BillingNote");
      } else {
        name = i18n.t("Combined_Payment_Note");
      }
      break;
  }

  return name;
};

export const GetOptionShowModalVoidConfirmation = (journalRefType) => {
  let optionShowModalVoidConfirmation = Enums.OptionShowModalVoid.OnlyJournal;
  const canVoidWithTransactionList = [
    Enums.JournalRefType.Invoice,
    Enums.JournalRefType.Receipt,
    Enums.JournalRefType.PaymentReceipt,
    Enums.JournalRefType.TaxInvoice,
    Enums.JournalRefType.Expense,
    Enums.JournalRefType.CreditNote,
    Enums.JournalRefType.CreditNoteExpense,
    Enums.JournalRefType.DebitNote,
    Enums.JournalRefType.DebitNoteExpense,
    Enums.JournalRefType.Deposit,
    Enums.JournalRefType.ReceivedDeposit,
    Enums.JournalRefType.GoodsReceipt,
    Enums.JournalRefType.InvoiceReceipt,
  ];
  const canVoidWithPaymentList = [
    Enums.JournalRefType.PaymentInvoice,
    Enums.JournalRefType.PaymentExpense,
    Enums.JournalRefType.BillingNoteInvoice,
    Enums.JournalRefType.BillingNoteExpense,
    Enums.JournalRefType.PaymentCreditNote,
    Enums.JournalRefType.PaymentCreditNoteExpense,
    Enums.JournalRefType.PaymentDebitNote,
    Enums.JournalRefType.PaymentDebitNoteExpense,
    Enums.JournalRefType.PaymentDeposit,
    Enums.JournalRefType.PaymentReceivedDeposit,
    Enums.JournalRefType.PaymentInvoiceReceipt,
  ];
  const canVoidWithAdjustProductStock = [Enums.JournalRefType.AdjustProductTemplateAmountStockActivityId];
  const canVoidWithBankAccount = [Enums.JournalRefType.BankAccount];
  if (canVoidWithTransactionList.includes(journalRefType)) {
    optionShowModalVoidConfirmation = Enums.OptionShowModalVoid.WithTransaction;
  } else if (canVoidWithPaymentList.includes(journalRefType)) {
    optionShowModalVoidConfirmation = Enums.OptionShowModalVoid.WithPayment;
  } else if (canVoidWithAdjustProductStock.includes(journalRefType)) {
    optionShowModalVoidConfirmation = Enums.OptionShowModalVoid.AdjustProductAmount;
  } else if (canVoidWithBankAccount.includes(journalRefType)) {
    optionShowModalVoidConfirmation = Enums.OptionShowModalVoid.BankTransfer;
  }
  return optionShowModalVoidConfirmation;
};

export default {
  GetCreateJournal(createOrEdit, allocationList = []) {
    return GetCreateJournal(createOrEdit, allocationList);
  },
  GetCreateJournalItem() {
    return GetCreateJournalItem();
  },
  CalculateJournal(journal) {
    return CalculateJournal(journal);
  },
  GetJournalStatus(status, isDeleted, validationStatus) {
    return GetJournalStatus(status, isDeleted, validationStatus);
  },
  GetJournalTypeDropdown() {
    return GetJournalTypeDropdown();
  },
  ValidateJournal(journal) {
    return ValidateJournal(journal);
  },
  ValidateJournalBeforeUpdate(journal) {
    return ValidateJournalBeforeUpdate(journal);
  },
  ValideteBeforeCreateJournal(journal) {
    return ValideteBeforeCreateJournal(journal);
  },
  SetJournalForEdit(journalTemplate, journalDetail, isCopy) {
    return SetJournalForEdit(journalTemplate, journalDetail, isCopy);
  },
  RedirectToDocumentDetail(referenceId, journalRefType) {
    return RedirectToDocumentDetail(referenceId, journalRefType);
  },
  CheckCanRedirectToDocumentDetail(journalRefType) {
    return CheckCanRedirectToDocumentDetail(journalRefType);
  },
  SelectJournalAccount(journalItemAccount, account) {
    SelectJournalAccount(journalItemAccount, account);
  },
  SelectJournalSubAccount(journalSubAccountItem, subAccount) {
    SelectJournalSubAccount(journalSubAccountItem, subAccount);
  },
  SetDescriptionSubAccount(journalItem, subAccountItem) {
    SetDescriptionSubAccount(journalItem, subAccountItem);
  },
  RemoveSubAccountFromDescription(journalItem) {
    RemoveSubAccountFromDescription(journalItem);
  },
  SetDescriptionAccount(journalItem, item) {
    SetDescriptionAccount(journalItem, item);
  },
  GetBankAccountListForSelectSubAccount(accountCode, bankAccountList) {
    return GetBankAccountListForSelectSubAccount(accountCode, bankAccountList);
  },
  GetReversedJournalDescription(description, oldNumber) {
    return GetReversedJournalDescription(description, oldNumber);
  },
};
